import { initAccordion } from './components/accordion';
import { initInstagramFeed } from './instagram';
import { initTestimonialCarousel } from './testimonial';

document.addEventListener('DOMContentLoaded', () => {
  initAccordion();
  initShowMoreReviewsBtn();
  initQuantity();
  initTabBtns();
  initHeroCarousel();
  initItemCarousel();
  initInstagramFeed();
  initTestimonialCarousel();
  setDeliveryCountdown();
});

function initQuantity() {
  const minus = document.getElementById(
    'qty-minus',
  ) as HTMLButtonElement | null;
  const plus = document.getElementById('qty-plus') as HTMLButtonElement | null;
  const qty = document.getElementById(
    'bundle-quantity',
  ) as HTMLInputElement | null;
  if (!minus || !plus || !qty) return;

  const addToCartBtn = document.getElementById(
    'bundle-add-to-cart',
  ) as HTMLButtonElement | null;
  const stickyBtn = document.getElementById(
    'bundle-sticky-add-to-cart',
  ) as HTMLButtonElement | null;
  const bannerBtn = document.getElementById(
    'bundle-banner-add-to-cart',
  ) as HTMLButtonElement | null;
  const savingsEl = document.getElementById(
    'bundle-savings-amount',
  ) as HTMLElement | null;
  const unitPrice = parseFloat(
    addToCartBtn?.dataset.unitPrice ??
      stickyBtn?.dataset.unitPrice ??
      bannerBtn?.dataset.unitPrice ??
      '0',
  );
  const unitSaving = parseFloat(savingsEl?.dataset.unitSaving ?? '0');

  function updateCtaText(quantity: number) {
    const total = (unitPrice * quantity).toLocaleString('en-GB', {
      style: 'currency',
      currency: 'GBP',
    });
    const text = `Add to Cart · ${total}`;
    if (addToCartBtn) addToCartBtn.textContent = text;
    if (stickyBtn) stickyBtn.textContent = text;
    if (bannerBtn) bannerBtn.textContent = text;
    if (savingsEl) {
      savingsEl.textContent = (unitSaving * quantity).toLocaleString('en-GB', {
        style: 'currency',
        currency: 'GBP',
      });
    }
  }

  minus.addEventListener('click', () => {
    const v = parseInt(qty.value);
    if (v > 1) {
      qty.value = String(v - 1);
      updateCtaText(v - 1);
    }
  });
  plus.addEventListener('click', () => {
    const v = parseInt(qty.value) + 1;
    qty.value = String(v);
    updateCtaText(v);
  });
}

function initTabBtns() {
  document.querySelectorAll<HTMLElement>('.bundle-tab-btn').forEach((btn) => {
    btn.addEventListener('click', () => {
      const target = btn.dataset.bundleTab;
      document.querySelectorAll<HTMLElement>('.bundle-tab-btn').forEach((b) => {
        b.classList.toggle('border-primary', b.dataset.bundleTab === target);
        b.classList.toggle('text-primary', b.dataset.bundleTab === target);
        b.classList.toggle(
          'border-transparent',
          b.dataset.bundleTab !== target,
        );
        b.classList.toggle(
          'text-muted-foreground',
          b.dataset.bundleTab !== target,
        );
      });
      document
        .querySelectorAll<HTMLElement>('[data-bundle-panel]')
        .forEach((p) => {
          p.classList.toggle('hidden', p.dataset.bundlePanel !== target);
        });
    });
  });
}

function addSwipe(el: HTMLElement, onSwipe: (dir: 1 | -1) => void) {
  let startX = 0;
  let dragging = false;

  // Touch
  el.addEventListener(
    'touchstart',
    (e) => {
      startX = e.touches[0].clientX;
    },
    { passive: true },
  );
  el.addEventListener('touchend', (e) => {
    const diff = startX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) onSwipe(diff > 0 ? 1 : -1);
  });

  // Mouse
  el.addEventListener('mousedown', (e) => {
    startX = e.clientX;
    dragging = true;
    e.preventDefault();
  });
  el.addEventListener('mousemove', (e) => {
    if (dragging) e.preventDefault();
  });
  el.addEventListener('mouseup', (e) => {
    if (!dragging) return;
    dragging = false;
    const diff = startX - e.clientX;
    if (Math.abs(diff) > 40) onSwipe(diff > 0 ? 1 : -1);
  });
  el.addEventListener('mouseleave', () => {
    dragging = false;
  });
}

function initHeroCarousel() {
  const heroTrack = document.getElementById(
    'hero-carousel-track',
  ) as HTMLElement | null;
  const heroThumb = document.getElementById(
    'hero-carousel-thumb',
  ) as HTMLElement | null;
  const heroPrev = document.getElementById(
    'hero-carousel-prev',
  ) as HTMLButtonElement | null;
  const heroNext = document.getElementById(
    'hero-carousel-next',
  ) as HTMLButtonElement | null;
  if (!heroTrack) return;
  const heroTotal = heroTrack.children.length;
  let heroCurrent = 0;
  function heroGoTo(index: number) {
    heroCurrent = (index + heroTotal) % heroTotal;
    heroTrack!.style.transform = `translateX(-${heroCurrent * 100}%)`;
    if (heroThumb) heroThumb.style.left = `${(heroCurrent / heroTotal) * 100}%`;
  }
  heroPrev?.addEventListener('click', () => heroGoTo(heroCurrent - 1));
  heroNext?.addEventListener('click', () => heroGoTo(heroCurrent + 1));
  addSwipe(heroTrack, (dir) => heroGoTo(heroCurrent + dir));

  const heroThumbRow = heroThumb?.parentElement as HTMLElement | null;
  if (heroThumbRow) {
    heroThumbRow.style.cursor = 'pointer';
    heroThumbRow.style.touchAction = 'none';
    heroThumbRow.style.transition = 'height 0.15s ease';
    function heroSeekTo(clientX: number) {
      const rect = heroThumbRow!.getBoundingClientRect();
      const pct = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
      heroGoTo(Math.min(Math.floor(pct * heroTotal), heroTotal - 1));
    }
    heroThumbRow.addEventListener('pointerdown', (e) => {
      heroThumbRow.setPointerCapture(e.pointerId);
      heroThumbRow.style.height = '8px';
      heroSeekTo(e.clientX);
    });
    heroThumbRow.addEventListener('pointermove', (e) => {
      if (e.buttons === 0) return;
      heroSeekTo(e.clientX);
    });
    heroThumbRow.addEventListener('pointerup', () => {
      heroThumbRow.style.height = '';
    });
    heroThumbRow.addEventListener('pointercancel', () => {
      heroThumbRow.style.height = '';
    });
  }
}

function initItemCarousel() {
  const track = document.getElementById(
    'item-carousel-track',
  ) as HTMLElement | null;
  const thumb = document.getElementById(
    'item-carousel-thumb',
  ) as HTMLElement | null;
  const prevBtn = document.getElementById(
    'item-carousel-prev',
  ) as HTMLButtonElement | null;
  const nextBtn = document.getElementById(
    'item-carousel-next',
  ) as HTMLButtonElement | null;
  if (!track) return;
  const container = track.parentElement as HTMLElement;
  const total = track.children.length;
  let current = 0;
  function stepWidth() {
    return container ? container.clientWidth + 24 : 0;
  }
  function goTo(index: number) {
    current = (index + total) % total;
    track!.style.transform = `translateX(-${current * stepWidth()}px)`;
    if (thumb) thumb.style.width = `${((current + 1) / total) * 100}%`;
  }
  prevBtn?.addEventListener('click', () => goTo(current - 1));
  nextBtn?.addEventListener('click', () => goTo(current + 1));
  window.addEventListener('resize', () => goTo(current));

  const THRESHOLD = 50;
  let dragStart: number | null = null;
  let dragging = false;

  function onDragStart(x: number) {
    dragStart = x;
    dragging = false;
    track!.style.transition = 'none';
  }
  function onDragMove(x: number) {
    if (dragStart === null) return;
    const diff = x - dragStart;
    if (Math.abs(diff) > 5) dragging = true;
    if (!dragging) return;
    track!.style.transform = `translateX(${-current * stepWidth() + diff}px)`;
  }
  function onDragEnd(x: number) {
    if (dragStart === null) return;
    track!.style.transition = '';
    const diff = x - dragStart;
    dragStart = null;
    dragging = false;
    if (Math.abs(diff) > THRESHOLD) goTo(current + (diff < 0 ? 1 : -1));
    else goTo(current);
  }

  container.addEventListener('mousedown', (e) => onDragStart(e.clientX));
  window.addEventListener(
    'mousemove',
    (e) => {
      if (dragStart !== null) {
        e.preventDefault();
        onDragMove(e.clientX);
      }
    },
    { passive: false },
  );
  window.addEventListener('mouseup', (e) => onDragEnd(e.clientX));

  container.addEventListener(
    'touchstart',
    (e) => onDragStart(e.touches[0].clientX),
    { passive: true },
  );
  container.addEventListener(
    'touchmove',
    (e) => {
      if (dragging) e.preventDefault();
      onDragMove(e.touches[0].clientX);
    },
    { passive: false },
  );
  container.addEventListener('touchend', (e) =>
    onDragEnd(e.changedTouches[0].clientX),
  );

  container.addEventListener('click', (e) => {
    if (dragging) e.stopPropagation();
  });

  const thumbRow = thumb?.parentElement as HTMLElement | null;
  if (thumbRow) {
    thumbRow.style.cursor = 'pointer';
    thumbRow.style.touchAction = 'none';
    function seekTo(clientX: number) {
      const rect = thumbRow!.getBoundingClientRect();
      const pct = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
      goTo(Math.min(Math.floor(pct * total), total - 1));
    }
    thumbRow.addEventListener('pointerdown', (e) => {
      thumbRow.setPointerCapture(e.pointerId);
      seekTo(e.clientX);
    });
    thumbRow.addEventListener('pointermove', (e) => {
      if (e.buttons === 0) return;
      seekTo(e.clientX);
    });
  }
}

function initShowMoreReviewsBtn() {
  const btn = document.getElementById(
    'show-more-reviews-btn',
  ) as HTMLButtonElement | null;
  const reviewsContainer = document.getElementById(
    'product-reviews',
  ) as HTMLElement | null;

  if (!btn || !reviewsContainer) return;

  btn.addEventListener('click', () => {
    const reviewsToShow = reviewsContainer.querySelectorAll(
      '.product-review.hidden',
    );

    reviewsToShow.forEach((review, index) => {
      if (index > 5) return;
      review.classList.remove('hidden');

      if (index === reviewsToShow.length - 1) {
        btn.classList.add('hidden');
      }
    });
  });
}

function setDeliveryCountdown() {
  document.addEventListener('cutoff-time', (event) => {
    const timerElement = document.getElementById('shipping-delivery-countdown');
    if (!timerElement) return;
    let animating = false;

    const e = event as CustomEvent;
    const timeString = e.detail.cutoffTime;
    if (!timeString) return;

    const updateCountdown = (cutoffTime: Date) => {
      setInterval(() => {
        const now = new Date();
        let timeRemaining = Math.max(0, cutoffTime.getTime() - now.getTime());
        const hours = Math.floor(timeRemaining / (1000 * 60 * 60));
        timeRemaining %= 1000 * 60 * 60;
        const minutes = Math.floor(timeRemaining / (1000 * 60));
        timeRemaining %= 1000 * 60;
        const seconds = Math.floor(timeRemaining / 1000);

        timerElement.textContent =
          hours > 0
            ? `${hours}h ${minutes}m ${seconds}s`
            : `${minutes}m ${seconds}s`;
      }, 1000);
    };

    const today = new Date();
    const [hours, minutes, seconds] = timeString.split(':').map(Number);
    const cutoffTime = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate(),
      hours,
      minutes,
      seconds,
    );
    const pastTodaysCutoffTime = cutoffTime < today;
    if (!cutoffTime) return;

    if (pastTodaysCutoffTime) {
      cutoffTime.setDate(cutoffTime.getDate() + 1);
    }

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            animating = entry.isIntersecting;
            if (animating) {
              requestAnimationFrame(() => {
                updateCountdown(cutoffTime);
              });
            } else animating = false;
          });
        },
        { threshold: 0.0 },
      );
      observer.observe(timerElement);
    } else {
      document.addEventListener('scroll', function () {
        const rect = timerElement.getBoundingClientRect();
        const inView = rect.top < window.innerHeight && rect.bottom >= 0;
        if (inView && !animating) {
          animating = true;
          requestAnimationFrame(() => {
            updateCountdown(cutoffTime);
          });
        } else if (!inView && animating) {
          animating = false;
        }
      });
    }
  });
}
